import React, { useEffect, useState } from "react";
import parse from "html-react-parser";

import PageHeaderLight from "../components/shared/PageHeaderLight";
import {
  loadMessageReplies,
  loadProfile,
  loadSupportMessage,
  saveReply,
  getCachedProfile,
  setCachedProfile,
} from "../utils/Network";
import { getDefaultValue, logout } from "../utils";
import { useStateValue } from "../StateProvider";
import DashboardHeaderProfileWidget from "../components/widgets/DashboardHeaderProfileWidget";
import "./Dashboard.css";

export default function MessageDetailsContent({ id }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [done, setDone] = useState(false);

  const [reply, setReply] = useState("");
  const [replies, setReplies] = useState(null);
  const [message, setMessage] = useState(null);
  const [threadLoading, setThreadLoading] = useState(true);
  const [profile, setProfile] = useState(() => getCachedProfile());

  const [{ translations }] = useStateValue();
  const translate = (str) => {
    if (!translations) return str;
    var translate = translations.find(
      (x) => x.key.toLowerCase() == str.toLowerCase()
    );

    if (translate) return getDefaultValue(translate);
    else return "#" + str;
  };

  useEffect(() => {
    loadProfile().then((data) => {
      if (data) {
        setProfile(data);
      } else {
        logout();
        window.location.href = "signin";
      }
    });
  }, []);

  useEffect(() => {
    let cancelled = false;
    setThreadLoading(true);
    Promise.all([loadSupportMessage(id), loadMessageReplies(id)])
      .then(([msg, response]) => {
        if (cancelled) return;
        setMessage(msg);
        setReplies(response && response.results ? response.results : []);
      })
      .finally(() => {
        if (!cancelled) setThreadLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [id]);

  const saveChanges = (e) => {
    if (reply == "") {
      setError(translate("Please Enter Reply"));
      return;
    }

    setLoading(true);
    setDone(false);
    setError(false);

    saveReply(id, reply).then((response) => {
      var t = [response, ...(replies || [])];
      setReplies(t);

      setLoading(false);
      setDone(true);
      setReply("");
    });
  };

  const handleChange = (e) => {
    switch (e.target.name) {
      case "reply":
        setReply(e.target.value);
        break;
      default:
        break;
    }
  };

  return (
    <div className="participant-dashboard">
      <div role="main" className="main page-background">
        <PageHeaderLight />
        <div className="container participant-dashboard__container pt-3 pb-5">
          <div className="row pt-2 lan-rtl align-items-start participant-dashboard__row">
            <div className="col-12 participant-dashboard__main participant-support-thread">
              <header className="participant-dashboard__header">
                <div className="participant-dashboard__header-inner">
                  <DashboardHeaderProfileWidget
                    profile={profile}
                    onProfileUpdated={(p) => {
                      setProfile(p);
                      setCachedProfile(p);
                    }}
                  />
                </div>
              </header>
              <div className="participant-dashboard__header-copy lan-text-right">
                <h1 className="participant-dashboard__title font-weight-bold line-height-3 text-7 mb-0">
                  {translate("Support")}
                </h1>
                {message && (
                  <p className="participant-dashboard__subtitle mb-0">
                    {message.title}
                  </p>
                )}
                {!message && threadLoading && (
                  <p className="participant-dashboard__subtitle mb-0 text-muted">
                    …
                  </p>
                )}
              </div>

              <section className="participant-support-thread__card section py-3 m-0 border-0 border-top-primary mb-4 brb-5">
                <div className="row lan-rtl">
                  <div className="col-md-12 col-sm-12 pr-4 pl-4 lan-text-right">
                    <div className="row form-group p-2">
                      <textarea
                        name="reply"
                        value={reply}
                        onChange={handleChange}
                        placeholder={translate("Write your reply here ...")}
                        className="form-control"
                      />
                    </div>
                    <div className="row pull-right form-group p-1">
                      <button
                        type="button"
                        onClick={saveChanges}
                        disabled={loading}
                        className="btn btn-primary width-200 btn-block text-uppercase font-weight-bold text-3 py-10"
                        data-loading-text="Loading..."
                      >
                        <i className="fas fa-reply op-7"></i>&nbsp;
                        {translate("Send Reply")}
                      </button>
                    </div>
                  </div>
                </div>
                {loading && (
                  <div className="alert alert-info mx-3">Please wait...</div>
                )}
                {error && (
                  <div className="alert alert-danger mx-3">{error}</div>
                )}
                {done && (
                  <div className="alert alert-success mx-3">
                    Reply Saved Successfully
                  </div>
                )}
              </section>

              {replies?.map((replyItem) => (
                <section
                  key={replyItem.id}
                  className="participant-support-thread__card section py-3 m-0 border-0 border-top-primary mb-4 brb-5"
                >
                  <div className="row mb-3 px-2">
                    <div className="col-md-12 px-0 border-bottom border-bottom-primary">
                      <div className="pull-right mt-1">
                        &nbsp;&nbsp;
                        <i className="fa fa-clock"></i>&nbsp;
                        {replyItem.updated_at
                          .replace("T", " ")
                          .replace("Z", " ")}
                      </div>
                    </div>
                  </div>
                  <div className="row lan-rtl">
                    <div className="p-2 lan-text-right">
                      {parse(replyItem.message)}
                    </div>
                  </div>
                </section>
              ))}

              {message && (
                <section
                  key={message.id}
                  className="participant-support-thread__card section py-3 m-0 border-0 border-top-primary mb-4 brb-5"
                >
                  <div className="row mb-3 px-2">
                    <div className="col-md-12 px-0 border-bottom border-bottom-primary">
                      <h2 className="font-weight-normal text-6 mb-0 title-cont lan-text-right">
                        <span className="text-color-light">
                          {message.user.profile.first_name}
                          &nbsp; {message.user.profile.last_name}
                        </span>
                      </h2>
                      <div className="pull-right mx-2 mt-1">
                        &nbsp;&nbsp;
                        <i className="fa fa-clock"></i>&nbsp;
                        {message.updated_at
                          .replace("T", " ")
                          .replace("Z", " ")}
                      </div>
                    </div>
                  </div>
                  <div className="lan-rtl">
                    <div className="lan-text-right participant-support-thread__message-body">
                      <p className="font-weight-bold text-4 mb-1" title="Subject">{message.title}</p>
                      <p className="font-color-silver" title="Message">{message.message}</p>
                    </div>
                  </div>
                </section>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
